import { Box, Paper, Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import SearchIcon from "../../assets/search-icon.svg";
import "./StudentListOverlay.css";
import useTranslationSetup from "../../utils/useTranslationSetup";
import varnamalaLevel from "../../assets/varnamala_level.svg";
import gradeLevel from "../../assets/grade_level.svg";
import {
  getBorderClass,
  getResultUrlParams,
} from "../../utils/CommonUtils/constants";
import useParamValues from "../../utils/useParamValues";

const StudentListOverlay = ({ results, searchTerm, onCloseList }) => {
  const { t } = useTranslationSetup();
  const navigate = useNavigate();
  const useParamValue = useParamValues();

  useEffect(() => {
    document.documentElement.classList.add("overlay-open");
    return () => document.documentElement.classList.remove("overlay-open");
  }, []);

  return (
    <Box className="student-list-overlay-box" onClick={onCloseList}>
      <Paper
        className="student-list-overlay-paper"
        onClick={(e) => e.stopPropagation()}
      >
        {searchTerm.trim() && results.length === 0 ? (
          <Box className="no-student-list-overlay">
            <img src={SearchIcon} alt="search-icon" />
            <Typography className="no-student-list-overlay-text">
              {t("no_student_found")}
            </Typography>
          </Box>
        ) : (
          results.map((student, i) => (
            <Box
              className="student-overlay-list-item"
              onClick={() =>
                navigate(
                  `/result?${getResultUrlParams(useParamValue, student)}`,
                  { state: { showBack: true } }
                )
              }
              key={i}
            >
              <Box
                className={`student-color-indicator ${getBorderClass(student.cohort)}`}
              />

              <Box className="student-info">
                <Box display="flex" alignItems="center">
                  <Typography className="cohort-student-name">
                    {student.name}
                  </Typography>
                  {student.badge === 2 && (
                    <img
                      src={varnamalaLevel}
                      alt="varnamala badge"
                      className="varnamala-badge-icon"
                    />
                  )}
                  {student.badge === 1 && (
                    <img
                      src={gradeLevel}
                      alt="grade badge"
                      className="student-badge-icon"
                    />
                  )}
                </Box>
                <KeyboardArrowRightIcon className="student-arrow" />
              </Box>
            </Box>
          ))
        )}
      </Paper>
    </Box>
  );
};

export default StudentListOverlay;
